import { lazy, Suspense } from "react";

import ModuleEmptyPage from "../components/emptyPage";

const BackHEMSOverview = lazy(() => import("../page/back/hems/overview"));
const BackHEMSUsageStatistic = lazy(() =>
  import("../page/back/hems/usageStatistic")
);

const routeItems = [
  {
    path: "hems/overview",
    element: <BackHEMSOverview />,
  },
  {
    path: "hems/usageStatistic",
    element: <BackHEMSUsageStatistic />,
  },
];

const routes = [
  ...routeItems.map((item) => ({
    path: item.path,
    element: <Suspense>{item.element}</Suspense>,
  })),

  {
    path: "*",
    element: <ModuleEmptyPage />,
  },
];

export default {
  routes,
};
